import React from 'react';

import Image from 'next/image';
import { Syringe } from 'phosphor-react';

export enum WagmiConnectorIds {
  METAMASK_ID = 'metaMask',
  COINBASE_ID = 'coinbaseWallet',
  WALLETCONNECT_ID = 'walletConnect',
  BITKEEP_ID = 'bitkeepInjected',
  INJECTED_ID = 'injected',
}

export const WagmiConnectorConfig: Record<
  WagmiConnectorIds,
  { name: string; icon: (width: number, height: number) => JSX.Element }
> = {
  [WagmiConnectorIds.METAMASK_ID]: {
    name: 'MetaMask',
    icon: (width, height) => <Image src="/img/wallet/metamask-fox.svg" width={width} height={height} />,
  },
  [WagmiConnectorIds.COINBASE_ID]: {
    name: 'Coinbase',
    icon: (width, height) => <Image src="/img/wallet/coinbase.png" width={width} height={height} />,
  },
  [WagmiConnectorIds.WALLETCONNECT_ID]: {
    name: 'Wallet Connect',
    icon: (width, height) => (
      <Image src="/img/wallet/walletconnect-circle-blue.svg" width={width} height={height} />
    ),
  },
  [WagmiConnectorIds.BITKEEP_ID]: {
    name: 'BitKeep',
    icon: (width, height) => <Image src="/img/wallet/bitkeep.webp" width={width} height={height} />,
  },
  [WagmiConnectorIds.INJECTED_ID]: {
    name: 'Injected Wallet',
    icon: (width, height) => <Syringe color={'white'} width={width} height={height} />,
  },
};

export default WagmiConnectorConfig;
